import { EventEmitter } from 'events';

/**
 * Application-wide event emitter for cross-component communication
 * Used for events that need to be handled globally across the app
 */

export const APP_EVENTS = {
    SESSION_EXPIRED: 'session_expired',
};

export const appEventEmitter = new EventEmitter();

